import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';

const FormSwitch = styled(Switch)(({ theme }) => ({
  width: 77,
  height: 32,
  padding: 0,
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 28,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(9px)',
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: 'none',
    width: 28,
    height: 28,
    borderRadius: 14,
    position: 'relative',
    transition: theme.transitions.create(['width'], {
      duration: 250,
    }),
    '&::before': {
      position: 'absolute',
      top: 6,
      left: 6,
      width: 16,
      opacity: 0,
      transition: theme.transitions.create(['opacity'], {
        duration: 250,
      }),
      content: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='${theme.palette.primary.contrastText.replace('#', '%23')}' d='M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z'%3E%3C/path%3E%3C/svg%3E")`,
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(45px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
      },
      '& .MuiSwitch-thumb': {
        '&::before': {
          opacity: 1,
        },
      },
    },
  },
  '& .MuiSwitch-track': {
    borderRadius: 16,
    opacity: 1,
    boxSizing: 'border-box',
  },
}));

export default FormSwitch;
